import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA as MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Observable } from "rxjs";

export interface ConfirmationDialogData {
  title: string;
  content: string;
  buttonLabel: string;
  destructiveButton?: boolean;
  confirmable?: boolean;
  confirmAction?: () => Observable<unknown>;
  pendingLabel?: string;
  failureMessage?: string;
  onConfirmError?: (error: unknown) => void;
}

@Component({
  selector: "app-confirmation-dialog",
  templateUrl: "./confirmation-dialog.component.html",
  styleUrls: ["./confirmation-dialog.component.scss"],
  standalone: false,
})
export class ConfirmationDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: ConfirmationDialogData) {}
}
